import { BifrostBackendNestApi } from "../gateways/BifrostBackendApi";

const SallingShopInfoProvider = {
	async getShopsWithCoordinates(brand, coords) {
		const url = `/viking-api/stores?brand=${brand}&coords=${coords}&radius=100&per_page=20`;
		return BifrostBackendNestApi.get(url);
	},

	async getHolidays(startDate, endDate) {
		const url = `/viking-api/holidays?startDate=${startDate}&endDate=${endDate}`;
		return BifrostBackendNestApi.get(url);
	}
};

export default Object.freeze(SallingShopInfoProvider);
